import { AfterViewInit, Directive, ElementRef } from "@angular/core";
import { LocalStorageService } from "../../edtell-caching/services/local-storage.service";

@Directive({
    selector:'[edtellLinkVisited]'
})
export class EdtellLinkVisited implements AfterViewInit {

    constructor(
        private localStorageService: LocalStorageService,
        private host: ElementRef
    ) {
    }
    
    ngAfterViewInit() {
        let href = this.host.nativeElement.getAttribute('href');
        let visitedPaths = this.localStorageService.getLocalStorageItem('visitedPaths');
        let visitedPathsList = [];
        
        if (visitedPaths != null) {
            visitedPathsList = JSON.parse(visitedPaths);
        }
        
        if (visitedPathsList.includes(href)) {
            this.host.nativeElement.classList.add('visited-link');
        }
    }
}